import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=0a83769b&"
import script from "./Group.vue?vue&type=script&lang=ts&"
export * from "./Group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports